/**
 * Loved by Customers
 * Lightweight, dependency-free lightbox gallery.
 * Uses event delegation so it scales to hundreds of blocks
 * without binding a listener per image, and re-initializes
 * cleanly with the Shopify theme editor.
 */

(function () {
  'use strict';

  var SELECTOR_TRIGGER = '[data-lightbox-trigger]';
  var SELECTOR_LIGHTBOX = '[data-lightbox]';
  var SELECTOR_OVERLAY = '[data-lightbox-overlay]';
  var SELECTOR_CLOSE = '[data-lightbox-close]';
  var SELECTOR_IMAGE = '[data-lightbox-image]';
  var FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var OPEN_CLASS = 'loved-by-customers__lightbox--open';
  var BODY_LOCK_CLASS = 'loved-by-customers-lightbox-active';

  /** Tracks the trigger button that opened each lightbox, keyed by section id. */
  var lastTriggerBySection = Object.create(null);

  /** Tracks whether a given lightbox is currently open, keyed by section id. */
  var openStateBySection = Object.create(null);

  /** Saved scroll position while body scroll is locked. */
  var lockedScrollY = 0;
  var scrollLocked = false;

  function getSectionId(el) {
    return el.getAttribute('data-section-id') || '';
  }

  function findLightboxForSection(sectionId) {
    var lightboxes = document.querySelectorAll(SELECTOR_LIGHTBOX);
    for (var i = 0; i < lightboxes.length; i++) {
      if (getSectionId(lightboxes[i]) === sectionId) {
        return lightboxes[i];
      }
    }
    return null;
  }

  function anyLightboxOpen() {
    for (var key in openStateBySection) {
      if (Object.prototype.hasOwnProperty.call(openStateBySection, key) && openStateBySection[key]) {
        return true;
      }
    }
    return false;
  }

  function getOpenLightbox() {
    var lightboxes = document.querySelectorAll(SELECTOR_LIGHTBOX);
    for (var i = 0; i < lightboxes.length; i++) {
      if (!lightboxes[i].hidden) {
        return lightboxes[i];
      }
    }
    return null;
  }

  function getFocusableElements(container) {
    if (!container) {
      return [];
    }
    return Array.prototype.slice.call(container.querySelectorAll(FOCUSABLE_SELECTOR));
  }

  function lockBodyScroll() {
    if (scrollLocked) {
      return;
    }
    lockedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + lockedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.classList.add(BODY_LOCK_CLASS);
    scrollLocked = true;
  }

  function unlockBodyScroll() {
    if (!scrollLocked) {
      return;
    }
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.classList.remove(BODY_LOCK_CLASS);
    window.scrollTo(0, lockedScrollY);
    scrollLocked = false;
  }

  function openLightbox(trigger) {
    var wrapper = trigger.closest('[data-section-id]');
    var sectionId = wrapper ? getSectionId(wrapper) : '';
    var lightbox = findLightboxForSection(sectionId);

    if (!lightbox) {
      return;
    }

    var imageEl = lightbox.querySelector(SELECTOR_IMAGE);
    var closeButton = lightbox.querySelector(SELECTOR_CLOSE);
    var fullSrc = trigger.getAttribute('data-full-src');
    var fullWidth = trigger.getAttribute('data-full-width');
    var fullHeight = trigger.getAttribute('data-full-height');
    var altText = trigger.getAttribute('data-alt') || '';

    if (!imageEl || !fullSrc) {
      return;
    }

    imageEl.setAttribute('src', fullSrc);
    imageEl.setAttribute('alt', altText);

    if (fullWidth) {
      imageEl.setAttribute('width', fullWidth);
    } else {
      imageEl.removeAttribute('width');
    }

    if (fullHeight) {
      imageEl.setAttribute('height', fullHeight);
    } else {
      imageEl.removeAttribute('height');
    }

    lastTriggerBySection[sectionId] = trigger;
    openStateBySection[sectionId] = true;

    lightbox.hidden = false;
    lightbox.classList.add(OPEN_CLASS);
    lockBodyScroll();

    if (closeButton && typeof closeButton.focus === 'function') {
      closeButton.focus({ preventScroll: true });
    }

    document.addEventListener('keydown', handleKeydown, true);
  }

  function closeLightbox(lightbox) {
    if (!lightbox || lightbox.hidden) {
      return;
    }

    var sectionId = getSectionId(lightbox);
    var imageEl = lightbox.querySelector(SELECTOR_IMAGE);

    lightbox.hidden = true;
    lightbox.classList.remove(OPEN_CLASS);
    openStateBySection[sectionId] = false;

    if (!anyLightboxOpen()) {
      unlockBodyScroll();
      document.removeEventListener('keydown', handleKeydown, true);
    }

   if (imageEl) {
  imageEl.removeAttribute('src');
  imageEl.removeAttribute('srcset');
  imageEl.removeAttribute('alt');
  imageEl.removeAttribute('width');
  imageEl.removeAttribute('height');
}

    var trigger = lastTriggerBySection[sectionId];
    if (trigger && document.contains(trigger) && typeof trigger.focus === 'function') {
      trigger.focus({ preventScroll: true });
    }

    delete lastTriggerBySection[sectionId];
  }

  function trapFocus(event, lightbox) {
    var focusable = getFocusableElements(lightbox);
    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var active = document.activeElement;

    if (event.shiftKey) {
      if (active === first || !lightbox.contains(active)) {
        event.preventDefault();
        last.focus();
      }
    } else {
      if (active === last || !lightbox.contains(active)) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  function handleKeydown(event) {
    var openLightboxEl = getOpenLightbox();
    if (!openLightboxEl) {
      return;
    }

    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      closeLightbox(openLightboxEl);
      return;
    }

    if (event.key === 'Tab') {
      trapFocus(event, openLightboxEl);
    }
  }

  function handleClick(event) {
    var trigger = event.target.closest(SELECTOR_TRIGGER);
    if (trigger) {
      event.preventDefault();
      openLightbox(trigger);
      return;
    }

    var closeButton = event.target.closest(SELECTOR_CLOSE);
    if (closeButton) {
      event.preventDefault();
      closeLightbox(closeButton.closest(SELECTOR_LIGHTBOX));
      return;
    }

    var lightbox = event.target.closest(SELECTOR_LIGHTBOX);

if (
  lightbox &&
  !event.target.closest('.loved-by-customers__lightbox-content')
) {
  event.preventDefault();
  closeLightbox(lightbox);
}
  closeLightbox(lightbox);
}

  function init() {
    document.addEventListener('click', handleClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /**
   * Theme editor support: if a section containing an open lightbox
   * is deselected, reloaded, or removed, make sure it closes cleanly
   * instead of leaving a stray open overlay, a locked scroll, or a
   * broken focus target.
   */
  document.addEventListener('shopify:section:unload', function (event) {
    var sectionId = event && event.detail ? event.detail.sectionId : null;
    if (!sectionId) {
      return;
    }

    var lightbox = findLightboxForSection(sectionId);
    if (lightbox && !lightbox.hidden) {
      closeLightbox(lightbox);
    }

    delete lastTriggerBySection[sectionId];
    delete openStateBySection[sectionId];
  });

  document.addEventListener('shopify:section:select', function (event) {
    var sectionId = event && event.detail ? event.detail.sectionId : null;
    if (!sectionId) {
      return;
    }

    var lightbox = findLightboxForSection(sectionId);
    if (lightbox && !lightbox.hidden) {
      closeLightbox(lightbox);
    }
  });

  window.addEventListener('pagehide', function () {
    if (scrollLocked) {
      unlockBodyScroll();
    }
  });
})();